import React, { useState } from 'react';
import { Col, Card, Modal } from 'react-bootstrap';

function ReadMoreBlog(props) {
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="feedback"
        >
            <Modal.Header closeButton className="p-3">
                <Modal.Title id="contained-modal-title-vcenter">
                    {props.blog.title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <div className="d-flex justify-content-center">
                    <img className="img-fluid mx-auto" src={props.blog.image} alt="" style={{
                        height: '400px'
                    }} />
                </div>
                <p className="mt-4">
                    {props.blog.content}
                </p>
            </Modal.Body>
        </Modal >
    );
}



const DashboardBlog = ({ blog, handleDeleteBlog }) => {
    const [modalShow, setModalShow] = useState(false);
    return (
        <div>
            <Col className="h-100">
                <Card className="text-start">
                    <Card.Img variant="top" src={blog.image} />
                    <Card.Body className="d-flex flex-column justify-content-between">
                        <div>
                            <Card.Title className="fw-bold">
                                {blog.title}
                            </Card.Title>
                            <Card.Text>
                                {blog.content.slice(0, 200)}...
                            </Card.Text>
                        </div>
                        <div className="mt-4">
                            <button onClick={() => setModalShow(true)} className="btn btn-outline-success">READ MORE</button>
                            <button onClick={() => handleDeleteBlog(blog._id)} className="btn btn-danger ms-3">DELETE BLOG <i className="fa fa-trash"></i> </button>
                        </div>
                    </Card.Body>
                </Card>
            </Col>


            <ReadMoreBlog
                blog={blog}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </div>
    );
};

export default DashboardBlog;